/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types typedef-whitespace */
import {
  AfterViewInit,
  Component,
  OnDestroy,
  ViewChild
}                                from '@angular/core';

import {Scenario}                from '@/models/scenario/scenario';
import {Logger}                  from '@/util/logger';
import {UnDoRedo}                from '@/util/un.do.redo';
import {DiversionEditor}         from '@/screens/ide/diversion/diversion.editor';
import {DiversionSummaryTable}   from '@/screens/ide/diversion/diversion.summary.table';
import {DiversionChange}         from '@/screens/ide/diversion/diversion.change';
import {DiversionInlineEdit}     from '@/screens/ide/diversion/diversion.inline.edit';
import {BlobService}             from '@/services/blob.service';
import {AlertService}            from '@/services/alert.service';
import {ICommand}                from '@/util/i.command';
import {AddDiversionCommand}     from '@/screens/ide/diversion/add.diversion.command';
import {DeleteDiversionCommand}  from '@/screens/ide/diversion/delete.diversion.command';
import {BlobType}                from '@/models/blob';

import {DiversionSchema}         from '@/models/scenario/diversion.schema';
import {Tabs}                    from '@/components/tabs';

import KeyDownEvent = JQuery.KeyDownEvent;

import * as $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {
  BehaviorSubject,
  Subscription
}                                from 'rxjs';
import {first}                   from 'rxjs/operators';
import {basename, empty} from "@/util/util";
import {StatusReporter} from "@/util/status.reporter";


@Component({
  selector: 'diversion-editor-component',
  template: `

    <!-- the work blox loader drop down -->
    <div class="dv-loader-wrapper" (click)="$event.stopPropagation();">

      <div
        class="dv-expander"
        (click)="toggleLoader()"
        [class.disabled]="scenarioKey !== ''"
        [innerHTML]="expanderElement"
        title="Select Scenario">
      </div>

      <div
        class="dv-save-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '') || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="saveScenario()"
        [innerHTML]="saveScenarioElement"
        title="Save Scenario">
      </div>
      <div
        class="dv-download-scenario"
        [class.disabled]="(scenario === null) || (scenarioKey === '') || !canAdd()"
        [class.editorbusy]="editorBusy"
        (click)="downloadScenario()"
        [innerHTML]="downloadScenarioElement"
        title="Download Scenario">
      </div>
      <div
        class="dv-clear-input"
        [class.disabled]="!hasInput()"
        [class.editorbusy]="editorBusy"
        (click)="clearCurrentInput()"
        [innerHTML]="clearDiversionElement"
        title="Clear input data">
      </div>
      <div
        [ngClass]="{'dv-add-diversion': true, 'disabled': !canAdd()}"
        (click)="addNewDiversion()"
        [class.editorbusy]="editorBusy"
        [innerHTML]="addDiversionElement"
        title="Add new diversion"></div>
      <div
        class="dv-delete-diversion"
        [class.disabled]="!isDeletable()"
        [class.editorbusy]="editorBusy"
        (click)="deleteDiversion()"
        [innerHTML]="deleteDiversionElement"
        title="Delete diversion"></div>
      <div
        class="dv-undo"
        [class.disabled]="undoManager.undoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="undo()"
        [innerHTML]="undoElement"
        title="Undo last change"></div>
      <div
        class="dv-redo"
        [class.disabled]="undoManager.redoSize() === 0"
        [class.editorbusy]="editorBusy"
        (click)="redo()"
        [innerHTML]="redoElement" title="Redo last change"></div>

      <div class="dv-loader-panel" [class.expanded]="loaderActive">
        <div id="dv-loader-form-drop-area_{{u}}" class="dv-loader-form-drop-area drop-area">

            <p>To select a new scenario, drop a scenario on this dashed area, or click Browse.</p>
            <input
              (change)="onFileBrowse($event.target.files); $event.stopPropagation(); false"
              type="file"
              id="dv-loader-upload_{{u}}"
              class="dv-loader-upload"
              style="display: none !important;">

          <label
              class="gui-button primary"
              for="dv-loader-upload_{{u}}"
              (click)="browseClick($event); $event.stopPropagation(); false">
              Browse
            </label>

        </div>

        <div class="dv-scenario-name">
          <span class="dv-scenario-label">Scenario:</span>
          <span class="dv-scenario-title" [innerHTML]="scenarioTitle"></span>
        </div>


        <div *ngIf="errorLine!==''" id="dv-scenario-error_{{u}}" class="dv-scenario-error" [innerHTML]="errorLine">
        </div>

      </div>
    </div>

    <!-- outer shell for the work blox editor -->
    <div class="diversion-editor-shell" style="text-align:center">
      <diversion-editor
        (edit)="onEdit($event)"

        uuid={{u}}
        id="dv_ed_{{u}}">

      </diversion-editor>
    </div>

    <!-- outer shell for the diversion summaries -->
    <div class="diversion-editor-summary-shell" style="text-align:center">
      <tabs>
        <tab title="Summary">
          <diversion-summary-table  uuid={{u}} id="dv_st_{{u}}"></diversion-summary-table>
        </tab>

      </tabs>
    </div>
  `
})

export class DiversionEditorComponent implements AfterViewInit, OnDestroy, StatusReporter {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum:     number = 0;
  public u: number = DiversionEditorComponent.instanceNum;

  /** hint for window title, whatever we have for the basename of the scenario file */
  public           fileName: string      = '';

  /** the history manager for the diversion editor */
  public undoManager:           UnDoRedo = new UnDoRedo(`DiversionHistory`);

  /** the currently active row/selection/diversion */
  private selectedWorkBlock: BehaviorSubject<DiversionChange>;
  private selectSub:        Subscription = null;

  /** the most recent inline edit (single field) */
  private lastInlineEdit: BehaviorSubject<DiversionInlineEdit>;
  private editSub:          Subscription = null;

  /** track when the file drop area panel is shown */
  public  loaderActive:         boolean  = false;

  /** the content to show for the expand collapse button */
  public expanderElement:         string = '<i class="fas fa-angle-down"></i>';

  public clearDiversionElement:   string = '<i class="fas fa-ban"></i>';
  public addDiversionElement:     string = '<i class="fas fa-plus"></i>';
  public deleteDiversionElement:  string = '<i class="far fa-trash-alt"></i>';
  public undoElement:             string = '<i class="fas fa-undo"></i>';
  public redoElement:             string = '<i class="fas fa-redo"></i>';
  public saveScenarioElement:     string = '<i class="far fa-save"></i>';
  public downloadScenarioElement: string = '<i class="fas fa-file-download"></i>';

  /** set to true when actions should be blocked because the editor is busy */
  public editorBusy:              boolean = false;

  /* the visible name of the scenario being browsed */
  public   scenarioTitle:         string = '';

  /* the error feedback if required */
  public       errorLine:         string = '';

  /* the current scenario model */
  public       scenario:        Scenario = null;

  /* the object version of the JSON used to load the scenario */
  public           json: any;

  /* blob key of scenario if it was loaded from a blob */
  public    scenarioKey:          string = '';

  @ViewChild(DiversionEditor, {static: false})
  public         editor: DiversionEditor;

  @ViewChild(DiversionSummaryTable, {static: false})
  public table: DiversionSummaryTable;

  @ViewChild(Tabs, {static: false})
  private tabs: Tabs;

  /* general call back for when we reload */
  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private blobber: BlobService,
    private alerts:  AlertService
  ) {

    Logger.debug('[diversion] dynamically creating...');

    /* setup an observable selection that every one can subscribe to */

    this.selectedWorkBlock = new BehaviorSubject<DiversionChange>(null);

    this.selectSub = this.selectedWorkBlock.subscribe( (next: DiversionChange) => {

      this.selected(next);
    });

    /* setup an observable for the inline edits */

    this.lastInlineEdit = new BehaviorSubject<DiversionInlineEdit>(null);

    this.editSub = this.lastInlineEdit.subscribe( (next: DiversionInlineEdit) => {

      this.inlineEdited(next);
    });

  }

  /** handle single column changes in the editing inputs */
  public inlineEdited(edit: DiversionInlineEdit) {

    Logger.debug('[diversion] inline edit', edit);

    /* TODO: */

  }

  /** handle changes to which work block is selected */
  public selected(change: DiversionChange) {

    Logger.debug('[diversion] selection change', change);

    /* TODO: */



  }

  /** check if we have any input in the editing fields */
  public hasInput(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.hasInput();
  }

  /** check if the current editing input is a wor/WorkBlock that we can delete */
  public isDeletable(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if (this.editor === null) {

      return false;
    }

    return this.editor.isDeletable();
  }

  /** check to see if the current editing input is good enough to add as a new WorkBlock */
  public canAdd(): boolean {

    if (typeof this.editor === 'undefined') {

      return false;
    }

    if ((this.scenario === null) || (this.editor === null)) {

      return false;
    }

    return this.editor.isValid();
  }

  ngOnDestroy(): void {

    if (this.selectSub !== null) {

      /* unsubscribe our observer */

      this.selectSub.unsubscribe();
    }
  }

  ngAfterViewInit(): void {

    $('diversion-editor-component').keydown((e: KeyDownEvent) => {

      if (e.key.toLowerCase() === 'escape') {

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

      if (e.ctrlKey && (e.key.toLowerCase() == 'v')) {

        /* add */

        this.addNewDiversion();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'x')) {

        /* delete */

        this.deleteDiversion();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'z')) {

        /* undo */

        this.undo();

        e.preventDefault();
        e.stopPropagation();

        return false;

      } else if (e.ctrlKey && (e.key.toLowerCase() == 'y')) {

        /* redo */

        this.redo();

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

    });

    /* get the scenario drop box */

    const instanceId: string = `dvec_${this.u}`;

    Logger.debug(`[diversion] setting up drop zone..., instance id=${instanceId}...`);

    /* - - - - - -  add in drag n' drop behaviors */

    /* get the drop box */

    const dropArea: HTMLElement = $(`#dv-loader-form-drop-area_${this.u}`).get(0);

    /* prevent bubble up, we're handling drag n' drop for this area */

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

      dropArea.addEventListener(eventName, (e) => {

        e.preventDefault();
        e.stopPropagation();

      }, false);

    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#dv-loader-form-drop-area_${this.u}`).addClass('highlight');

      }, false);

    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, (e) => {

        $(`#dv-loader-form-drop-area_${this.u}`).removeClass('highlight');

      }, false);

    });

    dropArea.addEventListener('drop', (e) => {

      const dt = e.dataTransfer;

      this.onFileBrowse(Array.from(dt.files));

    }, false);

    /* tell the sub-components what history manager to use */

    this.editor.setHistory(this.undoManager);
    this.table.setHistory(this.undoManager);

    /* make sure next instance of editor is unique */

    DiversionEditorComponent.instanceNum++;
  }

  /** simple trigger for getting the hidden file button to pop its dialog */
  public browseClick(e: MouseEvent) {

    document.getElementById(`dv-loader-upload_${this.u}`).click();

    e.stopPropagation();

  }

  /** update the error line in the loader drop down */
  public status(msg: string =  '') {

    if (this.editor) {

      this.editor.status(msg);
    }

    Logger.info(`[diversion] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    if (this.editor) {

      this.editor.success(msg);
    }

    Logger.debug(`[diversion] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    if (this.editor) {

      this.editor.error(msg);
    }

    Logger.error(`[diversion] ${msg}`);
  }

  /** helper to convert the current scenario (and work blocks) into JSON string */
  public toText(): string {

    /*
     * hack alert; instead of writing the full serialization for the entire scenario and all the
     * various kinds of blocks inside it...we're just doing it incrementally, for now, use the
     * the exact JSON object we loaded...and just overwrite the 'workblocks > diversions' section.
     * Then, stringify that whole JSON, and save / download that string.
     *
     * This minimizes what we can mess up, because we're only twitching teh diversions part. There
     * may still be some conversion issues; because for example floating point numbers were read
     * in by the JSON parser built into the browser...which may...or may not...make the same
     * assumptions/implementation choices about parsing and outputing floating point numbers...we
     * have no control over that :(
     *
     */

    const     dvs: DiversionSchema = new DiversionSchema();
    const section:             any = dvs.render(Array.from(this.scenario.diversions().values()));

    if ( section === null) {

      Logger.error(`[diversion] can't convert to text: ${dvs.lastError}`);
      return null;
    }

    this.json.scenario['workblocks']['diversions'] = section.diversions;

    Logger.debug(`[diversion] new scenario:`, this.json);

    return JSON.stringify(this.json);
  }

  public saveScenario() {

    if ((this.scenario === null) || (this.scenarioKey === '')  || !this.canAdd()) {

      Logger.debug('[diversion] can not save right now.');

      return ;
    }

    if (this.editorBusy === true) {

      /* already saving */

      return ;
    }

    this.status("Saving scenario...");
    this.editorBusy = true;

    const text: string = this.toText();

    Logger.debug(`[diversion] saving (key='${this.scenarioKey}', sz=${text.length})...`);

    this.blobber.update(this.scenarioKey, text)
      .pipe(first())
      .subscribe(
        () => {

          this.success("Saving complete!");
          this.editorBusy = false;

          Logger.debug('[diversion] scenario saved.');

        },
        error => {

          this.editorBusy = false;
          this.error("Could not save: " + error);

          Logger.error('[diversion] can not save scenario: ', error);

          this.alerts.error(error.error.message, {autoClose: true});

        });
  }

  public downloadScenario() {

    if (this.editorBusy === true) {

      /* already saving */

      this.editorBusy = false;

      return ;
    }

    this.status("Starting download...");

    this.editorBusy = true;

    const text: string = this.toText();

    if (text === null) {

      Logger.debug(`[diversion] could not convert to text.`);

      this.editorBusy = false;

      return ;
    }

    Logger.debug(`[diversion] downloading (sz=${text.length})...`);

    const type: BlobType = BlobType.Scenario;
    const mime: string   = 'application/json';

    let keyBase = this.scenarioKey.substring(this.scenarioKey.lastIndexOf('/') + 1);

    if (!keyBase || keyBase === '' ) {

      keyBase = this.scenarioKey;
    }

    /* make a downloadable blob... */

    const blob = new Blob([text], { type: mime });
    const url  = window.URL.createObjectURL(blob);

    /* setup a fake one-time link with the right download name and the blob attached as the download */

    const element: HTMLAnchorElement = document.createElement('a');
    element.href                     = url;
    element.download                 = keyBase || 'download';
    element.style.display            = 'none';

    document.body.appendChild(element);

    /* do it */

    element.click();

    /* clean up */

    document.body.removeChild(element);

    this.editorBusy = false;
  }

  public clearCurrentInput() {

    Logger.debug(`[diversion] clearing current input.`);

    this.editor.clear();
    this.table.clearSelection();

  }

  public addNewDiversion() {

    this.status('Adding block...');

    if (!this.canAdd()) {

      Logger.error(`[diversion] can not add right now`);

      return ;
    }

    Logger.debug(`[diversion] adding new diversion...`);

    /* convert current input/selection to a change object we can use with a history command */

    const add: DiversionChange = this.table.getSelection();

    add.src = this;

    const cmd: ICommand        = new AddDiversionCommand(add, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Added.');
  }

  public deleteDiversion() {

    if (!this.isDeletable()) {

      Logger.error(`[diversion] can not delete right now.`);
      return ;
    }

    this.status('Deleting block...');

    Logger.debug(`[diversion] deleting diversion...`);

    /* convert current input/selection to a change object we can use with a history command */

    const del: DiversionChange = this.table.getSelection();

    del.src = this;

    const cmd: ICommand        = new DeleteDiversionCommand(del, this);

    /* use the command to do the add */

    cmd.execute();

    /* track in history */

    this.undoManager.insert(cmd);

    this.success('Deleted.');
  }

  public undo() {


    if (this.undoManager.undoSize() === 0) {

      Logger.error(`[diversion] can not undo right now.`);

      return ;
    }

    Logger.debug(`[diversion] undo ... `);

    this.undoManager.undo();
  }

  public redo() {

    if (this.undoManager.redoSize() === 0) {

      Logger.error(`[diversion] can not redo right now.`);

      return ;
    }

    Logger.debug(`[diversion] redo ... `);

    this.undoManager.redo();
  }

  /** react to the user browsing a local windows scenario file */
  public onFileBrowse(files: File[]) {

    if (!files || (files.length === 0)) {

      /* nothing to do */

      return ;
    }

    const upload: File = files[0];

    this.fileName = upload.name;

    Logger.debug('[diversion] setting scenario via file: ', upload);

    this.status('');

    /* read in the raw text */

    const reader = new FileReader();

    reader.onerror = (msg) => {

      this.error('Problems uploading: ' + msg);
    };

    reader.onload = (event: ProgressEvent<FileReader>) => {

      const text = event.target.result;

      this.fromText(String(text), this.fileName);

    };

    reader.readAsText(upload);
  }

  public fromText(text: string, key: string = '') {

    Logger.debug(`[diversion] loading from raw text (${key})...`);

    const de: DiversionEditorComponent = this;

    /* convert to JSON */

    de.scenarioKey = key;
    de.json        = null;

    de.fileName = '';

    if (!empty(key)) {

      de.fileName = basename(key);
    }


    try {

      de.json = JSON.parse(text);

    } catch (e) {

      Logger.error('[diversion] Can not parse scenario JSON: ' + e);
      de.error('Can not parse scenario JSON: ' + e);

      return ;
    }

    /* try to construct a new model */

    de.onScenarioLock('Building from JSON...');

    const newScenario: Scenario = new Scenario(de.json, null, de);

    de.onScenarioUnlock();

    if (!newScenario.isReady()) {

      Logger.error('[diversion] Could not read scenario: ' + newScenario.getError());
      de.error(`Can not build scenario from JSON.`);

      return ;
    }

    Logger.debug('[diversion] scenario created.');

    /* success */

    setTimeout( () => {

      de.setScenario(newScenario);

      if (de.loaderActive) {

        de.toggleLoader();

      }

      /* let any user of this component know that we have reloaded the view */

      de.reloaded();

    }, 600);

  }

  /** when the main editor does any edits, we have to refresh the summary views. */
  public onEdit(s: Scenario) {

  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    Logger.debug('[diversion] locking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    Logger.debug('[diversion] unlocking ' + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  /** set the scenario using the given JSON */
  public setScenario(s: Scenario) {

    Logger.debug('[diversion] setting new scenario...');

    this.scenarioTitle = `[<i>${s._author}</i>] ${s._tag}`;
    this.scenario      = s;
    this.status('');

    /* set the "model" */

    this.editor.setScenario(this.scenario);
    this.editor.setSelectionSubject(this.selectedWorkBlock);
    this.editor.setInlineEditSubject(this.lastInlineEdit);

    /* tell the summary table there is a new set of work blocks */

    this.table.setScenario(this.scenario);
    this.table.setSelectionSubject(this.selectedWorkBlock);
    this.table.setInlineEditSubject(this.lastInlineEdit);

    /* let the summary table capture user input */

    this.table.inputCapture = (): DiversionChange => {

      return this.editor.captureInput();
    };

    /* let the summary table restore user input */

    this.table.inputRestore = (snapshot: DiversionChange): void => {

      this.editor.restoreInput(snapshot);
    };




  }

  /** open the scenario loader drop down panel (or close it) */
  public toggleLoader() {

    if (this.loaderActive) {

      /* collapse */

      this.loaderActive    = false;
      this.expanderElement = '<i class="fas fa-angle-down"></i>';

      return ;
    }

    /* expand */

    this.loaderActive    = true;
    this.expanderElement = '<i class="fas fa-angle-up"></i>';
  }

}
